import { call, put, takeLatest } from "redux-saga/effects";

import {
  GET_CUSTOMER_RECENT_APPOINTMENTS,
  GOT_CUSTOMER_RECENT_APPOINTMENTS
} from "../customerRecentAppointment";
import { getLocalStorageItem, getOrgId } from "../../utils/helpers";
import { handleApiErrors, IsvalidId } from "./helpers";

/***** SAGA START ******/
export let getCustomerRecentAppointmentsFirstListApi = ({ customerId }) => {
  if (!getOrgId()) {
    logger.error("Org id should be defined before you execute this function");
    return;
  }
  return fetch(
    `${
      window.APP.apiPath
    }api/organization/${getOrgId()}/customers/${customerId}/bookings?view=sideloaded&page=1&size=1`,
    {
      headers: { Authorization: getLocalStorageItem("token_authorization") }
    }
  )
    .then(response => {
      return response.json().then(result => {
        if (result.code && result.code != 200) {
          return handleApiErrors(result);
        } else {
          return result;
        }
      });
    })
    .catch(error => {
      logger.error(error);
      throw error;
    });
};

export let getCustomerRecentAppointmentsFullApi = ({ customerId }, total) => {
  if (!getOrgId()) {
    logger.error("Org id should be defined before you execute this function");
    return;
  }

  if (IsvalidId(customerId)) {
    return fetch(
      `${
        window.APP.apiPath
      }api/organization/${getOrgId()}/customers/${customerId}/bookings?view=sideloaded&page=1&size=${total}`,
      {
        headers: { Authorization: getLocalStorageItem("token_authorization") }
      }
    )
      .then(response => {
        return response.json().then(result => {
          if (result.code && result.code != 200) {
            return handleApiErrors(result);
          } else {
            return result;
          }
        });
      })
      .catch(error => {
        logger.error(error);
        throw error;
      });
  } else {
    return handleApiErrors({ generalError: true });
  }
};

function* loadCustomerRecentAppointmentWithCustomerId(customerId) {
  //this function loads the customers list into redux
  try {
    const intermediateData = yield call(
      getCustomerRecentAppointmentsFirstListApi,
      customerId
    );
    if (!intermediateData || intermediateData.error) {
      yield put(intermediateData.error); // Yields effect to the reducer specifying the action type and user details
      // There are no results, just return current API data
    } if (intermediateData.total === 0) {
      yield put({ type: GOT_CUSTOMER_RECENT_APPOINTMENTS, data: intermediateData });
    } else {
      const data = yield call(
        getCustomerRecentAppointmentsFullApi,
        customerId,
        intermediateData.total
      );
      if (!data || data.error) {
        yield put(data.error); // Yields effect to the reducer specifying the action type and user details
      } else {
        yield put({ type: GOT_CUSTOMER_RECENT_APPOINTMENTS, data }); // Yields effect to the reducer specifying the action type and user details
      }
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

function* watchRequests() {
  yield* [
    takeLatest(
      GET_CUSTOMER_RECENT_APPOINTMENTS,
      loadCustomerRecentAppointmentWithCustomerId
    )
  ];
}

export default [watchRequests];
